export enum RepliersListingTransactionType {
  'Sale' = 'Sale',
  'Lease' = 'Lease',
}
